export enum ViewPoint {
  xsMax = 767,
  smMin = 768,
  smMax = 991,
  mdMin = 992,
  mdMed = 1024,
  mdMax = 1119,
  lgMin = 1200
}
